import { CSSProperties, FunctionComponent, ReactNode } from "react";

interface PageCardProps {
  children: ReactNode;
  className?: string;
  /** Padding alternativo. Default usa o mixin page-card (28px). */
  padding?: CSSProperties["padding"];
  /** Tag HTML. Default: section */
  as?: "section" | "div" | "article" | "aside";
  /** Estilos inline extras */
  style?: CSSProperties;
}

/**
 * Container padrao com o estilo "login card":
 * gradient diagonal + linha ciano no topo + glow + blur.
 *
 * Equivalente a: <section className="page-card">...</section>
 */
const PageCard: FunctionComponent<PageCardProps> = ({
  children,
  className = "",
  padding,
  as: Tag = "section",
  style,
}) => {
  const finalStyle: CSSProperties = padding ? { padding, ...style } : style ?? {};
  return (
    <Tag className={`page-card ${className}`.trim()} style={finalStyle}>
      {children}
    </Tag>
  );
};

export default PageCard;
